<template>
  <div class="d-flex flex-column justify-center align-center">
  <TriangleHeader :title="inquiry.section_title"/>
    <div class="text-center mb-10 mt-16">

      <div v-html="$t('inquiry_first_description')"></div>
      <div v-html="$t('inquiry_second_description')"></div>
    </div>
    <v-card width="90vw" class="pb-1 my-16">
      <v-card-title style="background: #25458c">
        <h4 class="warning--text">{{$t('inquiry')}}</h4>
        <v-spacer></v-spacer>
        <v-text-field
            style="max-width: 250px!important;"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            outlined
            filled
            dense

            height="40"
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-dialog
                v-model="supplierPriceDialog"
                max-width="400"
            >
              <v-card>
                <v-card-title class="text-h5">
                  {{ $t('participate_in_the_inquiry') }}
                </v-card-title>

                <v-card-text class="mt-3">
                  <v-text-field
                      v-model="price"
                      flat
                      outlined
                      filled
                      :label="$t('price')"
                  />
                  <v-text-field
                      v-model="amount"
                      flat
                      outlined
                      filled
                      :label="getUnitPrice()"
                  />
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                      color="red"
                      text
                      @click="supplierPriceDialog = false"
                  >
                    {{$t('cancel')}}
                  </v-btn>

                  <v-btn
                      color="primary"
                      text
                      @click="inquiryPrice()"
                  >
                    {{$t('save')}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
      <v-data-table
          :loading="loading"
          :headers="headers"
          :items="inquiry.topics"
          :search="search"
          hide-default-footer
          class="elevation-1"
      >
      <template v-slot:item.title="{ item }">
        <div class="title-wrap d-flex">
          <img style="width: 70px;" v-img :src="item.photo_file" v-if="item.photo_file" alt="">
          <span class="mr-2">{{ item.title }}</span>
        </div>
      </template>
        <template v-slot:item.action="{ item }">
        <div :class="$vuetify.breakpoint.smAndDown?'flex-column':'flex-row'" class="d-flex">
          <div  class="ml-4 inquiry-btn" @click="getInquiryPrice(item.id)">
            {{$t('suggested_prices')}}
          </div>
          <template>
            <div class="inquiry-btn" @click="()=>showSupplierPriceDialog(item)">
              {{ $t('participate_in_the_inquiry') }}
            </div>

            
          </template>
        </div>
        </template>
      </v-data-table>
      <v-pagination
          color="#f2c303"
          class="my-4"
          dark
          
          v-model="page"
          :length="pageCount"
      ></v-pagination>
    </v-card>
    <v-dialog
        v-model="inquiryPriceDialog"
        hide-overlay
    >
      <v-card>
        <v-card-title class="text-h5">
          {{$t('details_of_inquiry')}}
        </v-card-title>

        <v-card-text class="mt-3">
          <v-data-table
              :headers="inquiryPriceHeader"
              :items="supplierPrices"
              hide-default-footer
              class="elevation-1"
          >
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
              color="primary"
              text
              @click="inquiryPriceDialog=false"
          >
            {{$t('close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        :value="isSuccess"
        color="warning"
    >
      <p dir="auto" class="snackbar-text">اطلاعات با موفقیت ثبت شد</p>
    </v-snackbar>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {
  GET_INQUIRY,
  GET_INQUIRY_PRICE,
  GET_SUPPLIER_PRICE,
  POST_INQUIRY_PRICE
} from "../../store/invitedToCooperateManagement/action_type";
import TriangleHeader from "../../components/triangle_header/TriangleHeader";

export default {
  name: "inquiry",
  components: {TriangleHeader},
  data() {
    return {
      amount: '',
      price: '',
      selectedInquiry:null,
      isSuccess:false,
      supplierPriceDialog: false,
      inquiryPriceDialog: false,
      page: 1,
      pageCount: 1,
      search: '',
      headers: [
        {
          text: this.$t('inquiry_number'),
          align: 'start',
          sortable: false,
          value: 'inquiry_number',
        },
        {text: this.$t('title'), value: 'title'},
        {text: this.$t('date'), value: 'created_at_fa'},
        {text: this.$t('Goods Amount'), value: 'count'},
        {text: this.$t('Related Specialist'), value: 'expert'},
        {text: this.$t('Deadline for participating in inquiry'), value: 'deadline'},
        // {text: this.$t('Type'), value: 'type'},
        {text: this.$t('Action'), value: 'action'},
      ],
      sentInquiry:false,
      inquiryPriceHeader: [
        {
          text: 'شماره کالا/خدمات',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'تاریخ', value: 'created_at_fa'},
        {text: 'تعداد', value: 'amount'},
        {text: 'قیمت', value: 'formatted_price'},
        
      ],
    }
  },
  watch:{
    page(){
      this.getInquiry()
    }
  },
  computed: {
    ...mapState({
      inquiry: state => state.invitedToCooperateManagement.inquiry,
      loading: state => state.invitedToCooperateManagement.loading,
      isLoggedIn: state => state.authManagement.isLoggedIn,
      user: state => state.authManagement.user,
      supplierPrices:state => state.invitedToCooperateManagement.supplierPrices,
    })
  },
  methods: {
    getUnitPrice(item){
      if(!this.selectedInquiry) return;
      console.log(this.selectedInquiry)
      const options={
            "1":"گرم",
            "2":"کیلوگرم",
            "3":"تن",
            "4":"لیتر",
            "5":"مترمکعب",
            "6":"عدد",
        };     
        return (options[(this.selectedInquiry.fields.find(a=>a.title=="واحد کالا")?.value || "")] || "");                                  
  },
    onPageChange(){
      this.getInquiry()
    },
    getInquiry() {
      this.$store.dispatch(`invitedToCooperateManagement/${GET_INQUIRY}`,this.page)
      .then(res=>{
        this.pageCount=this.inquiry.total_page;
      });
    },
    showSupplierPriceDialog(item) {
      if (this.isLoggedIn != null || this.sentInquiry) {
        this.supplierPriceDialog = true;
        this.selectedInquiry=item;
      } else {
        this.$router.push("/login");
      }
    },

    inquiryPrice() {
      let item=this.selectedInquiry;
      this.$store.dispatch(`invitedToCooperateManagement/${POST_INQUIRY_PRICE}`, {
        price: this.price,
        amount: this.amount,
        inquiry_id: item.id,
        id:this.user?.supplier?.id
      }).then(res=>{
        this.sentInquiry=true;
        this.isSuccess=true
        this.supplierPriceDialog=false
      })

    },

    getInquiryPrice(id) {
      this.$store.dispatch(`invitedToCooperateManagement/${GET_SUPPLIER_PRICE}`, {
        id: id,
      }) .then(
          ()=>this.inquiryPriceDialog=true
      );
    }
  },
  created() {
    this.getInquiry();
  }
}
</script>

<style scoped>
.inquiry-btn{
  margin: 8px 0;
  width: 140px;
  font-size: 13px;
  height: 30px;
  background: #25458c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FCC300;
  cursor: pointer;
}
.inquiry-btn:hover{
  background: #FCC300;
  color: #25458c;
}
</style>